import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LoginModal from "../../../components/LoginModal";
import { Administrator } from "../../../services/models/administrator";
import { LoginCredentials } from "../../../services/models/credentials";
import * as AdministratorsApi from "../../../services/network/administrator-api";
import styleUtils from "../../../assets/styles/utils.module.css";
import styleAuth from "../../../assets/styles/AuthPage.module.css";

interface AdminAuthPageProps {
    onLoginSuccessful: (admin: Administrator) => void,
}

const AdministratorAuthPage = ({onLoginSuccessful}: AdminAuthPageProps) => {
    let navigate = useNavigate();
    const routeChange = () =>{
        let path = `cabinet`;
        navigate(path);
    }
    async function onSubmit(credentials: LoginCredentials) {
        try {
            const user = await AdministratorsApi.login(credentials);
            localStorage.setItem("user", JSON.stringify(user))
            onLoginSuccessful(user);
            routeChange();
        } catch (error) {
            toast.error("Неверный логин или пароль");
            console.error(error);
        }
    }

    return (
        <>
            <h1 className={`${styleUtils.flexCenter} ${styleAuth.authAdminTitle}`} >Авторизация администратора</h1>
            <LoginModal onSubmit={onSubmit}/>
        </>
        
);
}

export default AdministratorAuthPage;